module.exports = __webpack_public_path__ + "img/34.1.edc46725.jpg";